var React = require('react');

function Ball32 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M50,85l6.667,6.667c5,5,11.667,8.333,18.333,8.333h0c13.333,0,25-11.667,25-25h0c0-6.667-3.333-13.333-6.667-18.333L85,50l6.667-6.667c5-5,8.333-11.667,8.333-18.333h0C100,11.667,88.333,0,75,0h0C68.333,0,61.667,3.333,56.667,6.667L50,15,43.333,6.667C38.333,3.333,31.667,0,25,0h0C11.667,0,0,11.667,0,25H0c0,6.667,3.333,13.333,6.667,18.333L15,50,6.667,56.667C3.333,61.667,0,68.333,0,75H0c0,13.333,11.667,25,25,25h0c6.667,0,13.333-3.333,18.333-6.667Z"}));
}

Ball32.defaultProps = {"viewBox":"0 0 100 100"};

module.exports = Ball32;

Ball32.default = Ball32;
